import React from 'react';
import Modal from 'react-modal';

import { api } from '../../../services/api';

import { AiOutlineClose } from "react-icons/ai";

function ResetUserModal ({isOpen, onRequestClose, user}){
    async function resetUser(){
        try {
            await api.post('/user/update', {
                id: user.id_user,
                password: '123456'
            });
            onRequestClose(true, true);
        } catch (error) {
            let msg_error = undefined;
            
            if (error && error.response && error.response.data) {
                const errorData = error.response.data;
                if (typeof errorData.error === 'string') {
                  msg_error = errorData.error;
                }
            }

            onRequestClose(true, false, msg_error);
        }
        
    }

    return (
        <Modal
            ariaHideApp={false}
            overlayClassName="react-modal-overlay"
            className="react-modal-content react-modal-content-reset"
            isOpen={isOpen} 
            onRequestClose={onRequestClose}
        >
            <button 
                className="react-modal-close"
                onClick={onRequestClose} 
            >
                <AiOutlineClose />
            </button>
            <div className="react-modal-title">
                <h4 id="modal-title">Resetar Senha</h4>
            </div>

            <div className="react-modal-body">
                <span className="modal-text">
                    Tem certeza que deseja resetar a senha do usuário {user.name_user}?
                </span>
                <span className="modal-subtext">
                    Depois deste processo a senha será: 123456
                </span>
                <div className="react-modal-btn">
                    <button className="btn btn-red" onClick={onRequestClose} >
                        Cancelar
                    </button>
                    <button className="btn btn-blue" onClick={resetUser}>
                        Resetar
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ResetUserModal;